




import {
  defineComponent,
  onMounted,
  PropType,
  ref
} from '@nuxtjs/composition-api'

type TurnstileErrorType = 'load' | 'verify'

const TURNSTILE_SCRIPT_SRC =
  'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'

function loadTurnstileScript() {
  if (window.turnstile) {
    return Promise.resolve()
  }
  const existing = document.querySelector(
    `script[src="${TURNSTILE_SCRIPT_SRC}"]`
  )
  if (existing) {
    return new Promise<void>((resolve) => {
      existing.addEventListener('load', () => resolve(), { once: true })
    })
  }
  return new Promise<void>((resolve, reject) => {
    const script = document.createElement('script')
    script.src = TURNSTILE_SCRIPT_SRC
    script.async = true
    script.defer = true
    script.addEventListener('load', () => resolve(), { once: true })
    script.addEventListener('error', () => reject(new Error('load failed')), {
      once: true
    })
    document.head.appendChild(script)
  })
}

export default defineComponent({
  props: {
    siteKey: {
      type: String,
      default: process.env.TURNSTILE_SIGNUP_SITE_KEY
    },
    onVerify: {
      type: Function as PropType<(token: string) => void>,
      required: true
    },
    onError: {
      type: Function as PropType<(type: TurnstileErrorType) => void>,
      required: true
    }
  },
  setup(props) {
    const container = ref<Element>()
    const widgetId = ref<string>()

    onMounted(async () => {
      try {
        await loadTurnstileScript()
      } catch (error) {
        props.onError('load')
        return
      }

      widgetId.value = window.turnstile!.render(container.value, {
        sitekey: props.siteKey,
        callback: (token: string) => {
          props.onVerify(token)
        },
        'error-callback': () => {
          props.onError('verify')
        }
      })
    })

    const reset = () => {
      if (widgetId.value !== undefined) {
        window.turnstile!.reset(widgetId.value)
      }
    }

    return { container, reset }
  }
})
